import CustomButton from "components/Atoms/CustomButton"
import { withFormController } from "components/Molecules/FormController"
import currencySymbol from "locale/currency"
import React from "react"
import useOrderIds from "./useOrderIds"

const OrderHeader = ({ onChange }) => {
  const orders = useOrderIds()
  const isConsoliated = orders?.length > 0
  return (
    <div className="od-header od-row">
      <div>#</div>
      <div>Sellable Item</div>
      {isConsoliated && <div>Src. Rate ({currencySymbol}) </div>}
      <div>Rate ({currencySymbol})</div>
      <div className="flex flex-col items-center justify-center">
        <div>Quantity</div>
        {isConsoliated && <div className="text-xs">(Consolidated)</div>}
      </div>
      <div>Total ({currencySymbol})</div>
      <div>{isConsoliated ? "Ground Stock" : "Stock"}</div>
      <div>
        <CustomButton
          intent="danger"
          icon="trash"
          minimal
          onClick={e => onChange("orderItems", [])}
        />
      </div>
    </div>
  )
}

export default withFormController(OrderHeader)
